import React, { createContext } from 'react'

const Context = createContext(null)

const ContextProvider = ({ children }) => <Context.Provider value={{}}>{children}</Context.Provider>

export { Context, ContextProvider }
